import React from "react";
import styled from "styled-components";

const AboutSection = styled.section`
  padding: 60px 20px;
  background-color: #f8fafc;
  display: flex;
  flex-direction: column; /* Por defecto uno debajo del otro */
  align-items: center;    /* Centrado horizontal en mobile */
  justify-content: center;
  gap: 40px;
  overflow: hidden;

  @media (min-width: 992px) {
    flex-direction: row; /* Al llegar a desktop se ponen de lado */
    padding: 100px 8%;
    text-align: left;
    gap: 80px;
  }
`;

const TextContent = styled.div`
  flex: 1;
  max-width: 600px;
`;

const Badge = styled.span`
  color: #3c485a;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 0.8rem;
`;

const Title = styled.h2`
  font-size: clamp(2rem, 5vw, 2.2rem);
  color: #0f172a;
  margin: 15px 0 25px 0;
  line-height: 1.2;
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-top: 30px;
`;

const ServiceCard = styled.div`
  background: white;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.05);
    border-color: #3b82f6;
  }

  h4 {
    color: #1e293b;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1.1rem;
  }

  p {
    color: #64748b;
    font-size: 0.9rem;
    line-height: 1.5;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  max-width: 500px; /* Limitamos el ancho para que no sea gigante en tablets */
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  order: 2; /* Asegura que en mobile esté abajo del texto */

  @media (min-width: 992px) {
    flex: 1;
    max-width: 600px;
    order: unset; /* En desktop vuelve a su posición original */
  }

  img {
    width: 100%;       /* Ocupa el ancho del contenedor */
    height: auto;      /* Mantiene la proporción */
    max-height: 400px; /* Evita que crezca demasiado verticalmente */
    object-fit: contain;
    border-radius: 20px;
    filter: drop-shadow(0 20px 30px rgba(0,0,0,0.1));
    animation: float 6s ease-in-out infinite;
  }

  /* El brillo azul de fondo, ahora centrado */
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    height: 80%;
    background: radial-gradient(circle, rgba(59, 130, 246, 0.2) 0%, transparent 70%);
    filter: blur(40px);
    z-index: -1;
  }
`;

const About = () => {
  return (
    <AboutSection>
      <TextContent>
        <Badge>Expertos en Transformación Digital</Badge>
        <Title>Creamos soluciones web que impulsan tu crecimiento</Title>
        <p style={{ color: '#64748b', marginBottom: '30px' }}>
          No solo hacemos páginas, construimos herramientas de venta. Diseños 100% responsivos 
          con la última tecnología para que tu negocio nunca se detenga.
        </p>

        <ServicesGrid>
          <ServiceCard>
            <h4>🚀 Desarrollo</h4>
            <p>Landings, E-commerce y Webs autoadministrables de alto rendimiento.</p>
          </ServiceCard>

          <ServiceCard>
            <h4>🎨 Diseño</h4>
            <p>Interfaces modernas y creación de logos que definen tu identidad.</p>
          </ServiceCard>

          <ServiceCard>
            <h4>🔍 Estrategia</h4>
            <p>Posicionamiento SEO y seguridad SSL para que Google confíe en vos.</p>
          </ServiceCard>

          <ServiceCard>
            <h4>🛠️Incluido </h4>
            <p>Hosting y Dominio bonificados por el primer año. ¡Listo para usar!</p>
          </ServiceCard>
        </ServicesGrid>
      </TextContent>

      <ImageContainer>
        <img src="/img/RESPONS.webp" alt="Diseño web responsive" />
      </ImageContainer>
    </AboutSection>
  );
};

export default About;